import React from 'react';
import { CreditCardIcon, DumbbellIcon, FileTextIcon, LayersIcon, LockIcon, ShieldCheckIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
import { Button } from './ui/Button';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 min'], [DumbbellIcon, 'Principiante → Avanzado'], [LayersIcon, 'Todos los niveles'], [UsersIcon, 'Alumnos de todas las edades']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-170" data-mp="1274mtlq59a5n">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" data-id="element-171" data-mp="x8b85pz4fd3w" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-172" data-mp="nczt16jsw3vm">
        <div className="mb-5 inline-flex rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-primary md:mb-6" data-id="element-173" data-mp="nekqp51ew2xp">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.6rem]" data-id="element-174" data-mp="3j7zf9iqmlsgo">
          🏃‍♀️ Combo Completo Jumping 2026
          <span className="mt-3 block text-xl normal-case text-primary md:text-4xl" data-id="element-175" data-mp="39acy0plutotj">
            Todo tu año de clases de Jumping. Listo. Desde hoy.
          </span>
        </h1>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Combo Completo Jumping 2026" data-id="element-176" data-mp="3ebiripnc9g44">
          <img className="w-full max-w-[680px] object-contain drop-shadow-[0_26px_44px_rgba(219,39,119,.28)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Jumping 2026 con sus 5 módulos, 3 bonos y upsells" data-id="element-177" data-mp="359jahxcbqc16" />
        </a>

        <p className="mx-auto max-w-3xl text-base font-semibold leading-relaxed text-slate-600 md:text-xl" data-id="element-178" data-mp="2hk8685vrlzia">
          <strong className="text-ink" data-id="element-179" data-mp="2ljgz78izdtcs">
            🇦🇷 EL SISTEMA COMPLETO PARA INSTRUCTORES DE JUMPING EN ARGENTINA.
          </strong>{' '}
          Principiante → Avanzado, todos los niveles. Clases + combinaciones + adaptaciones listos para usar. Sin pasar horas buscando ejercicios. Sin improvisar clases. Sin perder tus domingos preparando contenido.  
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-180" data-mp="ddnenyoiclid">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-181" data-mp="1ayjilhmnxm7u">
              <BadgeIcon className="h-4 w-4 text-primary" data-id="element-182" data-mp="162capjapi0n9" />
              {label}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-183" data-mp="110wqtuk9m06g">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-184" data-mp="x1ef9pec31ga">
            🏃‍♀️ QUIERO MI COMBO JUMPING AHORA →
          </Button>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-185" data-mp="3lqm3c0xhx9vz">
          <span className="flex items-center gap-1" data-id="element-186" data-mp="1x9ukg9uwtbmw">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-187" data-mp="1x783xkq1jlsj" />
            Garantía 7 días
          </span>
          <span className="text-pink-300" data-id="element-188" data-mp="218jv3uokcf2u">·</span>
          <span className="flex items-center gap-1" data-id="element-189" data-mp="268y5hjdn0141">
            <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-190" data-mp="2b0pn34etewi1" />
            Pago seguro
          </span>
          <span className="text-pink-300" data-id="element-191" data-mp="2fzsugvi9pet6">·</span>
          <span className="flex items-center gap-1" data-id="element-192" data-mp="2fz0vrbtdj0yo">
            <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-193" data-mp="2kyvqxrk6mcpj" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-194" data-mp="2p08ufuzsy3ta">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-pink-100 bg-white p-4 text-center shadow-sm" data-id="element-195" data-mp="2tyir6a16dch0">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-196" data-mp="uo0to10suspl">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-197" data-mp="zmlthzc53adi">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}